import LazyLoadImage from '@bnnvara/lazy-load';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';
export function HalfImageHalfTextCardImage({
  image
}) {
  return /*#__PURE__*/React.createElement(S.ImageContainer, null, image.isLazyLoaded ? /*#__PURE__*/React.createElement(LazyLoadImage, {
    as: S.Image,
    src: image.src,
    alt: image.alt
  }) : /*#__PURE__*/React.createElement(S.Image, {
    src: image.src,
    alt: image.alt
  }));
}
HalfImageHalfTextCardImage.propTypes = {
  image: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    isLazyLoaded: PropTypes.bool,
    src: PropTypes.string.isRequired
  })
};